<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>1st G H Raisoni Memorial Katni International FIDE Rapid Rating Chess Tournament 2026</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>1st G H Raisoni Memorial Katni International FIDE Rapid Rating Chess Tournament 2026</span></h2>
        </div>
        <p><strong> Date: </strong>31st May 2026</p>
        <p><strong> Venue: </strong>Hotel The Arindum, Katni, Madhya Pradesh, India</p>
        <p><strong> Organised By: </strong>Katni District Chess Association, G H Raisoni Sports and Cultural Foundation &amp; Kalpana Prakash Welfare Foundation</p>

        <h5 class="primary-purple">Introduction:</h5>
        <p>The 1st G H Raisoni Memorial Katni International FIDE Rapid Rating Chess Tournament 2026,
            organized by Katni District Chess Association, G H Raisoni Sports and Cultural Foundation
            &amp; Kalpana Prakash Welfare Foundation. The event witnessed enthusiastic participation with
            278 registered players representing ten different states of India. The total prize fund was
            ₹2,00,000, with the winner receiving ₹31,000.
        </p>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>
                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/katni-intern-fide-rapid-rating-chess-tour.pdf"
                        width="100%" height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
